/* eslint-disable no-underscore-dangle, max-classes-per-file, no-return-assign  */
import { toaster } from 'evergreen-ui';
import { useMemo } from 'react';

function DataAdapterForRTKQAdapter(type) {
  return (data, prevData) => {
    if (!prevData) return data;
    if (type === 'lazyQuery') {
      const obj = { ...prevData[1], ...(Array.isArray(data) ? data[1] : data) };
      return Object.assign([prevData[0], obj]);
    }
    // if (type === 'query') ;
    return { ...prevData, ...data };
  };
}

class RTKQAdapter {
  constructor(options = RTKQAdapter.optionsDefault) {
    this.__options = { ...RTKQAdapter.optionsDefault, ...options };
  }
  // open Api

  getApi() {
    this.__options.getApi = true;
    return this.__return;
  }

  onErr(fn) {
    this.__options.err = fn;
    return this;
  }

  getById(id) {
    if (id) this.__addTask((result) => ({ element: result?.data?.find((el) => String(el?.id) === String(id)) }));
    else throw Error(`[Adapter argument error] getById(id) method argument expected: not void! But defined: ${id}`);
    return this.__return;
  }

  getByIndex(index) {
    this.__addTask((result) => ({ element: result.data?.[index] }));
    return this.__return;
  }

  get length() {
    return this.lengthByKey('data');
  }

  lengthByKey(key) {
    this.__addTask((result) => ({
      ...result,
      [`${key}Length`]: result[key]?.length,
    }));
    return this.__return;
  }

  filter(filterFn) {
    this.__addTask(filterFn);
    return this.__return;
  }

  get end() {
    this._checkForErr();
    this.__checkForGetApi();
    return this.__options.endFnCustom ? this.__options.endFnCustom(this) : this.__endFn();
  }

  // utils Api

  _addData(data) {
    return this.__options.data = this.__options?.dataAdapter?.(data, this._getData());
  }

  _getData() {
    return this.__options.data;
  }

  _checkForErr() {
    if (this.__options.err) {
      this.__addTask((result) => {
        if (result[this.__options.errKey]) this.__options.err(result);
      });
    }
    return this.__return;
  }

  // inside APi

  __checkForGetApi() {
    if (this.__options.getApi) {
      this.__addTask((result) => ({
        adapterApi: () => new RTKQAdapter({
          returnCustom: (context) => Object.values(context._endFn()(result) || { null: null })[0],
          saveProperties: false,
        }),
      }));
    }
  }

  get __return() {
    return this.__options.returnCustom ? this.__options.returnCustom(this) : this;
  }

  __stack = []

  __addToStack(fn) {
    if (this.__options.saveProperties) {
      this.__stack.push((result) => {
        const filterResult = fn(result);
        return filterResult ? { ...result, ...filterResult } : result;
      });
    } else this.__stack.push(fn);
  }

  __addTask(task) {
    if (this.__options.stackEndSystem) this.__addToStack(task);
    else this.__executeNow(task);
  }

  __executeNow(task) {
    if (typeof task !== 'function') console.error('[Adapter] Expected function! But defined: ', task);
    else this.__options.returnCustom = () => this.__options.data = { ...this.__options.data, ...task(this.__options.data) };
  }

  __endFn() {
    return (result) => this.__stack.reduce((prevResult, current) => current(prevResult), result);
  }

  static optionsDefault = {
    err: false,
    errKey: 'isError',
    getApi: false,
    saveProperties: true,
    stackEndSystem: true,
    dataAdapter: null,
    data: false,
    // name: 'data',
    endFnCustom: false,
    returnCustom: false,
  }

  __options = Object.create(RTKQAdapter.optionsDefault)
}

// Чтобы при перерендере онибка не выскакивала повторно
const brokenRequestIds = {};
function errToaster(err) {
  if (!brokenRequestIds[err?.requestId]) {
    brokenRequestIds[err.requestId] = true;
    console.log(err);
    toaster.danger(`Ошибка загрузки данных! ${err?.error?.data?.message}`);
  }
}

export function adapterOld(...options) {
  const outs = ['short', 'arg', 'custom'];
  const out = options.find((el) => outs.find((outEl) => outEl === el)) || outs[0];
  const many = options.find((el) => (el === 'many') || ((typeof el === 'boolean') && el));

  return new RTKQAdapter({
    endFnCustom: (context) => {
      let result;
      switch (out) {
        case outs[0]:
          result = [undefined, {
            selectFromResult: context.__endFn(),
          }];
          break;
        case outs[1]:
          result = {
            selectFromResult: context.__endFn(),
          };
          break;
        case outs[2]:
          result = context.__endFn();
          break;
        default:
          console.log(`Неизвестное значение "out" = ${out}`);
      }
      return result;
    },
    returnCustom: !many && ((context) => context.end),
  }).onErr(errToaster);
}

const usedKeys = ['filter', 'getById'];

// export const ADAPTER_HOOK_ARGS = {
//   UNINIT_EQUIVAL_LOADING: true,
//   ONLY_isSuccess: true,
// };

const createHook = (useHook, caseType) => function useCustomHook(...args) {
  const obj = useHook(...args);
  const adapterImpl = useMemo(() => new RTKQAdapter({ stackEndSystem: false, dataAdapter: DataAdapterForRTKQAdapter(caseType) }).onErr(errToaster), []);
  const additional = {
    __adapter__: {
      info: 'adapterForApi',
      addProperties(data) {
        return adapterImpl._addData(data);
      },
    },
    onErr(err) {
      if (err) adapterImpl.onErr(err);
      adapterImpl._checkForErr();
      return adapterImpl._getData();
    },
    get length() {
      return adapterImpl._getData()?.data?.length || 0;
    },
    createFilter(...createAdapterFilterArgs) {
      // eslint-disable-next-line no-use-before-define
      return adapterImpl.filter(createAdapterFilter(...createAdapterFilterArgs));
    },
    // dataIs(value) {
    //   const data = adapterImpl._getData();
    //
    //   return data?.data ? data : adapterImpl._addData({ data: value });
    // },
  };
  // Чтоб не терялся контекс (this) внутри адаптера:
  usedKeys.forEach((el) => {
    additional[el] = (...args1) => adapterImpl[el](...args1);
  });
  adapterImpl._addData(obj);
  setTimeout(() => adapterImpl._checkForErr(), 0);
  return adapterImpl._addData(additional);
};

const brokenHooks = {};

const cases = (key, value) => {
  if (!brokenHooks[key]) {
    if (key.match(/^useLazy.*Query$/)) {
      brokenHooks[key] = true;
      return createHook(value, 'lazyQuery');
    } if (key.match(/^use.*Query$/)) {
      brokenHooks[key] = true;
      return createHook(value, 'query');
    }
  }
  return false;
};

export const adapterForApi = (api) => {
  const keys = Object.keys(api);
  return keys.reduce((acc, objectKey) => {
    const r = cases(objectKey, api[objectKey]);
    acc[objectKey] = r || api[objectKey];
    return acc;
  }, {});
};

export const createAdapterFilter = (filterFn, name = 'filter') => (result) => {
  const data = result?.data || [];
  const filtered = filterFn(data, result);
  if (result?.__adapter__?.info === 'adapterForApi') return result.__adapter__.addProperties({ [usedKeys.includes(name) ? 'filtered' : name]: filtered });
  return { [name]: filtered };
};

export const filterGetById = (id, filterFn) => (data, result) => {
  const element = result?.element || (id && result?.getById(id)?.element);
  return filterFn(element, result, data);
};
// export const updateCachedArray = (endpointName, updatedElement) => dcpcApi.util.updateQueryData(endpointName, void 0, (draft) => {
//   const obj = {};
//   obj[draft.findIndex((el) => el.id === updatedElement.id)] = updatedElement;
//   Object.assign(draft, obj);
// });
